import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { loginSuperAdmin } from 'Src/helpers/service/superadmin/auth';

interface State {
  email: string;
  password: string;
  isLoading: boolean;
  error: string;
}

export class SuperAdminLogin extends React.Component<RouteComponentProps<{}>, State> {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      isLoading: false,
      error: ''
    };
  }

  onEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ email: event.target.value, error: '' });
  };

  onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ password: event.target.value, error: '' });
  };

  onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const { email, password } = this.state;

    this.setState({ isLoading: true, error: '' });

    loginSuperAdmin(email, password)
      .then(() => {
        this.props.history.push('/');
      })
      .catch(() => {
        this.setState({
          isLoading: false,
          error: 'Email or password is incorrect.'
        });
      });
  };

  render() {
    const { email, password, isLoading, error } = this.state;

    return (
      <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
        <div className="card" style={{ width: '420px' }}>
          <div className="card-body">
            <h1 className="h4 mb-3">Superadmin login</h1>
            <form onSubmit={this.onSubmit}>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={this.onEmailChange}
                  disabled={isLoading}
                  required
                />
              </div>
              <div className="form-group">
                <label>Password</label>
                <input
                  type="password"
                  className="form-control"
                  value={password}
                  onChange={this.onPasswordChange}
                  disabled={isLoading}
                  required
                />
              </div>
              {error && <div className="alert alert-danger">{error}</div>}
              <button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                {isLoading ? 'Signing in...' : 'Sign in'}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
